/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cancel_DescriptionInputs */

const vi_carrier_cancel_description = /** @type {(inputs: Carrier_Cancel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng chỉ cho huỷ khi chưa lấy hàng. Huỷ xong đơn có thể giao lại bằng cách khác.`)
};

/**

* @param {Carrier_Cancel_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cancel_description = /** @type {((inputs?: Carrier_Cancel_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cancel_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cancel_description(inputs)
});